<template>
	<v-data-table
		:headers="headers"
		:items="dispositivos"
		loading-text="Cargando Dispositivos"
		:loading="isloading"
		:footer-props="footer"
		no-data-text="No hemos encontrado datos..."
		locale="es"
	>
	<template v-slot:item.id_dispositivo="{item,value}">
		{{value}}
	</template>
	<template v-slot:item.os="{item,value}">
		{{value}}
	</template>
	<template v-slot:item.rango_afecto="{item,value}">
		{{value}}
	</template>
	<template v-slot:item.folio_afecto="{item,value}">
		{{(value == -1 ? "" : value)}}
	</template>
	<template v-slot:item.rango_exento="{item,value}">
		{{value}}
	</template>
	<template v-slot:item.folio_exento="{item,value}">
		{{(value == -1 ? "" : value)}}
	</template>
	<template v-slot:item.is_deshabilitado="{item,value}">
			<v-checkbox
              v-model="value"
              color="primary"
              class="align-center justify-center pt-0 mt-0"
              @click="openModal(item)"
              hide-details
              readonly
            ></v-checkbox>
	</template>
	</v-data-table>
</template>

<script>

export default {
	name: 'TablaDispositivos',
	props:{
		dispositivos:{
			type:Array,
			default:()=>{
				return [];
			}
		}
	},
	data () {
		return {
			isloading: false,
			footer: {
				'items-per-page-options': [5, 10, 15, 20, 30, 50, 100, 250]
			},
			headers:[
				{
					text: 'ID dispositivo',
					value: 'id_dispositivo',
					sortable:true
				},
				{
					text: 'Sistema Operativo',
					value: 'os',
					sortable:true
				},
				{
					text: 'Rango CAF AFECTO',
					value: 'rango_afecto',
					sortable:true
				},
				{
					text: 'Último folio AFECTO emitido',
					value: 'folio_afecto',
					sortable:true
				},
				{
					text: 'Rango CAF EXENTO',
					value: 'rango_exento',
					sortable:true
				},
				{
					text: 'Último folio EXENTO emitido',
					value: 'folio_exento',
					sortable:true
				},
				{
					text: 'Deshabilitar',
					value: 'is_deshabilitado',
					sortable:false
				}
			]

		}
	},
	methods:{
		openModal: function(item){
			if(!item.is_deshabilitado){
				this.$emit('openDialog',item);
			}else{
				this.$emit('dispositivoDisabled');
			}
			
		}
	}
}
</script>

<style lang="css" scoped>
</style>